//@ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import MapContainer from '../../Common/MapContainer';
import { selectTopBulletPoints } from './../../../selectors/DetailedDistrictReportSelectors';
import { clearSelectedDistrictId, downloadDetailedDistrictReport, getAllSpending, setSelectedDistrictId } from './../../../actions/DetailedDistrictReportActions';

import { getOrdinal, numberWithCommas, decimalNumberWithDollarSign, listOfDistricts } from './../../Common/Helpers';
import LoadingSpinner from '../../Common/LoadingSpinner';

// import event tracking log
import { withUserActionTracker } from "./../../../sharedUtilities/UserActionTracker";

class StateMap extends React.Component {

    state = {
        nationalMapUrl: "",
        //selectedDistrictId: 0
    }

    componentDidMount() {
        // load spending data
        this.props.getAllSpending(this.props.UserState.report_display_id, this.props.UserState.report_vintage_one_district);

        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] != undefined &&
            this.props.match.params["p1"] != undefined &&
            this.props.match.params["p2"] != undefined) {

            var url = `/reports/congressional-district-detail-report/${this.props.match.params["link_id"]}/${this.props.match.params["p1"]}/${this.props.match.params["p1"]}`

            this.setState({ nationalMapUrl: url })
        }
    }

    componentWillMount() {
        this.props.clearSelectedDistrictId();
    }

    downloadReportPDF = (congressId, stateName, vintage, displayId, min_year, max_year) => {
        // get username and user display id from user state object
        const { username, display_id, report_university_name } = this.props.UserState;

        // first display id is for the report, second display id is for the logged in user
        this.props.downloadDetailedDistrictReport(
            congressId,
            stateName,
            vintage,
            displayId,
            username,
            display_id,
            report_university_name,
            min_year,
            max_year,
            this.props.reportConfig.release_date
        );
    }

    const districtChange = (event) => {
        if (event.target.value != "") {
            this.props.setSelectedDistrictId(event.target.value);
        }
    };

    public render() {
        // get parameter details from match property on props
        const { match } = this.props;

        const stateName = this.props.USStateList.find(state => state.statecode == match.params.stateCode).statename;
        const displayId = this.props.UserState.report_display_id;
        const vintage = this.props.UserState.report_vintage_one_district;

        const districtSpendingInfo = null;
        const repInfo = "Vacant";

        if (this.props.allSpending) {
            districtSpendingInfo = this.props.allSpending.find(district => district.congress_id == this.props.selectedCongressId);
        }

        if (districtSpendingInfo) {
            repInfo = districtSpendingInfo.rep_name !== null ? ` - Rep. ${districtSpendingInfo.rep_name} (${districtSpendingInfo.rep_party})` : ` - ${repInfo}`;
        }

        const districtsInState = match.params.stateCode && listOfDistricts(match.params.stateCode);
        return (
            <div className={"state-map-container"}>
                <div className="state-map-heading-container">
                    <div className="row">
                        <div className="col-md-3">
                            <p className="report-text"><Link to={this.props.sharedLinkActive ? `${this.state.nationalMapUrl}` : "/reports/congressional-district-detail-report"}>← National Map</Link></p>
                            <h2 className="report-subheading">{match.params.stateCode ? `${stateName}` : `Nothing Here`}</h2>
                        </div>
                        <div className="col-md-9">
                            {
                                this.props.topBulletPoints &&
                                (+this.props.topBulletPoints.payment_amt != 0) &&
                                <a style={{ fontSize: "14px", cursor: "pointer", textDecoration: "none" }} className="button pdfdownload float-right" onClick={() => this.downloadReportPDF(this.props.selectedCongressId, stateName, vintage, displayId, this.props.reportConfig.min_year, this.props.reportConfig.max_year)}><i className="fa fa-download" style={{ marginRight: "4px" }}></i>Download PDF Report</a>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {
                                this.props.selectedCongressId && districtSpendingInfo
                                    ? <h4><span className="highlighted-subheading">{`${getOrdinal(+this.props.selectedCongressId.slice(2))} Congressional District`}</span>{repInfo}</h4>
                                    : <h4>Congressional Districts</h4>
                            }
                            {
                                this.props.topBulletPoints
                                ? <p className="p-compact">Research-Related Spending Summary, {this.props.topBulletPoints.min_year} - {this.props.topBulletPoints.max_year}</p>
                                : <p className="p-compact">Research-Related Spending Summary</p>
                            }
                        </div>
                    </div>
                </div>
                <hr />
                <div className={"row"}>
                    <div className="col-md-6">
                        <p className="action-headers">Select a congressional district to view summary and download report. <br />Scroll to zoom into map. Click and drag to pan.</p>
                    </div>
                    <div className="col-md-6">
                        <select style={{ fontSize: "14px", width: "300px" }} value={this.props.selectedCongressId} onChange={this.districtChange}>
                            {districtsInState.sort().map((option) => (
                                <option value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </div>
                    {this.props.allSpending &&
                        <div className={"col-md-8 col-sm-6 map-bg-shade"}>
                            {(match.params.stateCode) &&
                                <MapContainer
                                    agg={false}
                                    isInState={true}
                                    isZoomed={true}
                                    isCongress={true}
                                    state_fips={match.params.stateCode}
                                    mapData={this.props.allSpending}
                                    USState={this.props.USStateList}
                                    mapHasNoLegend={true}
                                    isDetailedDistrict={true}
                                    selectedDistrictId={this.state.selectedDistrictId}
                                />
                            }
                        </div>
                    }
                    {
                        this.props.selectedCongressId && this.props.topBulletPoints
                            ?
                            <div className={"col-md-4 col-sm-6 bullet-point-container"}>
                                <p className="report-text">
                                    <span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.community_college_count) + numberWithCommas(this.props.topBulletPoints.university_count)}</span>
                                    <br />
                                    {(this.props.topBulletPoints.community_college_count + this.props.topBulletPoints.university_count > 1) ? 'Community Colleges and Universities' : 'Community College or University'}
                                </p>
                                <p className="report-text"><span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.employee_count)}</span><br />Higher Education Faculty and Staff</p>
                                <p className="report-text"><span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.student_count)}</span><br />Undergraduate Students</p>
                                <p className="report-text"><span className="bullet-point-statistic">{decimalNumberWithDollarSign(this.props.topBulletPoints.payment_amt)}</span><br />Total Research-Related Spending by {this.props.UserState.report_university_name}</p>
                                <p className="report-text"><span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.business_count)}</span>
                                    <br />
                                    {(+this.props.topBulletPoints.business_count > 1)
                                        ? `Businesses Providing Research-Related Goods and Services to ${this.props.UserState.report_university_name}`
                                        : `Business Providing Research-Related Goods and Services to ${this.props.UserState.report_university_name}`}
                                </p>
                                {!(this.props.topBulletPoints.small_business_count == 0 && this.props.topBulletPoints.minority_owned_count == 0 && this.props.topBulletPoints.woman_owned_count == 0) &&
                                    <ul>
                                        {
                                            (this.props.topBulletPoints.small_business_count > 0) &&
                                            <li>
                                                <span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.small_business_count)}</span>
                                                {(+this.props.topBulletPoints.small_business_count > 1) ? ' Small Businesses' : ' Small Business'}
                                            </li>
                                        }
                                        {
                                            (this.props.topBulletPoints.minority_owned_count > 0) &&
                                            <li>
                                                <span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.minority_owned_count)}</span>
                                            {(+this.props.topBulletPoints.minority_owned_count > 1) ? ' Minority-Owned Businesses' : ' Minority-Owned Business'}
                                            </li>
                                        }
                                        {
                                            (this.props.topBulletPoints.woman_owned_count > 0) &&
                                            <li>
                                                <span className="bullet-point-statistic">{numberWithCommas(this.props.topBulletPoints.woman_owned_count)}</span>
                                            {(+this.props.topBulletPoints.woman_owned_count > 1) ? ' Woman-Owned Businesses' : ' Woman-Owned Business'}
                                            </li>
                                        }
                                    </ul>
                                }
                            </div>
                            :
                            placeHolderDistrictSelection
                    }
                    {
                        this.props.downloadInProgress &&
                        <LoadingSpinner loadingText="Processing PDF ..." />
                    }
                </div>
            </div>
        );
    }
}

const placeHolderDistrictSelection = <div className={"col-md-4 col-sm-6 no-selection"}>
    <div className="no-selection-box-1" />
    <div className="no-selection-box-2" />
    <div className="no-selection-box-3" />
    <div className="no-selection-box-1" />
    <div className="no-selection-box-2" />
    <div className="no-selection-box-3" />
    <div className="no-selection-box-1" />
    <div className="no-selection-box-2" />
    <div className="no-selection-box-3" />
</div>;

const mapStateToProps = state => ({
    UserState: state.userProperties,
    topBulletPoints: selectTopBulletPoints(state),
    allSpending: state.detailedDistrictReportProperties.allSpending,
    reportConfig: state.detailedDistrictReportProperties.reportConfig,
    sharedLinkActive: state.detailedDistrictReportProperties.sharedLinkActive,
    USStateList: state.allReportsSharedProperties.USStateList,
    spendingData: state.spendingReportProperties.SpendingCongressMap,
    selectedCongressId: state.detailedDistrictReportProperties.selectedCongressId,
    downloadInProgress: state.detailedDistrictReportProperties.downloadInProgress
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getAllSpending: getAllSpending,
            clearSelectedDistrictId: clearSelectedDistrictId,
            downloadDetailedDistrictReport: downloadDetailedDistrictReport,
            setSelectedDistrictId: congressId => dispatch(setSelectedDistrictId(congressId))
        }, dispatch
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(withUserActionTracker(StateMap, "Congressional District Detail Report", "viewed a state map"));